import { render, staticRenderFns } from "./DashboardHome.vue?vue&type=template&id=0a6c7ef8&scoped=true"
import script from "./DashboardHome.vue?vue&type=script&lang=js"
export * from "./DashboardHome.vue?vue&type=script&lang=js"
import style0 from "./DashboardHome.vue?vue&type=style&index=0&id=0a6c7ef8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6c7ef8",
  null
  
)

export default component.exports